export type SafeFetchInit = RequestInit & { retryOnCsrfMissing?: boolean };

let cachedCsrfToken: string | null = null;
let lastCsrfFetchedAt = 0;
const CSRF_TTL_MS = 30 * 60 * 1000; // 30 分鐘

async function ensureCsrfToken(): Promise<string> {
  const now = Date.now();
  if (cachedCsrfToken && (now - lastCsrfFetchedAt) < CSRF_TTL_MS) {
    return cachedCsrfToken;
  }
  
  // console.log('[safeFetch] 🔐 開始獲取 CSRF token...')
  const resp = await fetch('/api/csrf-token', { method: 'GET', credentials: 'same-origin' });
  
  if (!resp.ok) {
    // console.error('[safeFetch] ❌ CSRF token API 回應失敗:', {
    //   status: resp.status,
    //   statusText: resp.statusText
    // })
    throw new Error(`Failed to initialize CSRF token: ${resp.status} ${resp.statusText}`);
  }
  
  let data: any = {}
  try {
    data = await resp.json()
    // console.log('[safeFetch] 📥 收到 CSRF token 回應:', {
    //   hasToken: !!data.token,
    //   hasCsrfToken: !!data.csrf_token,
    //   keys: Object.keys(data)
    // })
  } catch (parseError) {
    // console.error('[safeFetch] ❌ 無法解析 CSRF token 回應:', parseError)
    throw new Error('Failed to parse CSRF token response');
  }
  
  // 支援兩種欄位名稱：token (新) 或 csrf_token (舊)
  const token = data?.token || data?.csrf_token;
  
  if (!token || typeof token !== 'string') {
    // console.error('[safeFetch] ❌ CSRF token 格式無效:', {
    //   tokenType: typeof token,
    //   tokenValue: token ? token.substring(0, 10) + '...' : null,
    //   responseData: data
    // })
    throw new Error('Invalid CSRF token response');
  }
  
  // console.log('[safeFetch] ✅ CSRF token 獲取成功')
  cachedCsrfToken = token;
  lastCsrfFetchedAt = now;
  return token;
}

export async function safeFetch(input: RequestInfo | URL, init: SafeFetchInit = {}): Promise<Response> {
  const method = (init.method || 'GET').toUpperCase();
  const isStateChanging = method !== 'GET' && method !== 'HEAD' && method !== 'OPTIONS';

  if (isStateChanging) {
    const headers = new Headers(init.headers || {});
    if (!headers.get('x-csrf-token')) {
      const token = await ensureCsrfToken();
      headers.set('x-csrf-token', token);
    }
    headers.set('Content-Type', headers.get('Content-Type') || 'application/json');
    return fetch(input, { ...init, headers, credentials: 'same-origin' });
  }

  return fetch(input, { ...init, credentials: 'same-origin' });
}
